import { ABaseModel, LineItem, MapType } from '@pperform/pp-data-mappers';

export class OrderLineItemDTO extends ABaseModel {
  shipmentPk = 0;

  @MapType([LineItem])
  lineItems: LineItem[] = [];

  trackingNumber = '';

  isShipmentEligibleForReturn = false;
}
